import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v2/channels', { params });
  },
  getByProfile(id, params) {
    return axios.get(`/v2/channel/profile/${id}`, params);
  }
};
